// extracted by mini-css-extract-plugin
export default {"wrapper":"PercentButton_wrapper__P1M2i","active":"PercentButton_active__RjkEs"};